import { createApp } from 'vue'
import registerVeeValidate from './plugins/vee-validate'
import registerBootstrap5 from './plugins/bootstrap5-components'
import registerModalService from './plugins/modal-service'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { AppConfigurationPlugin } from "vue3-app-configuration";
import * as Sentry from "@sentry/vue";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faPhone, faBars, faEnvelope, faCheck, faCalendar, faChevronUp, faTimes, faUndo, faPen, faInfo, faBan, faExclamation, faTachometerAlt, faUsersCog, faSkiing, faTrash, faDownload, faTasks, faCalculator, faEllipsisV, fas, faSnowboarding } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//import * as Sentry from '@sentry/browser';
//import * as Integrations from '@sentry/integrations';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'



library.add(faPlus, faBars, faEnvelope, faPhone, faCheck, faTrash, faCalendar, faChevronUp, faTimes, faUndo, faPen, faInfo, faBan, faExclamation, faTachometerAlt, faUsersCog, faSkiing, faDownload, faTasks, faCalculator, faEllipsisV, fas, faSnowboarding)

// TODO: Turn on Sentry

// Template plugin
import Template from './template'
import { AuthenticationContext } from '@/auth/msal-context'
import { toast } from "@/services/toast";

async function bootstrap() {
  await AuthenticationContext.initialize()

  const app = createApp(App)

  registerBootstrap5(app)
  registerModalService(app)
  registerVeeValidate(app)

  app.component('font-awesome-icon', FontAwesomeIcon)


  app.use(AppConfigurationPlugin, {
    connectionString: "Endpoint=https://ssu-config.azconfig.io;Id=CzdM;Secret=EMuNQsi3PomE2niotB4kbT4Ud0R3FiJznUzhGmm9vihApCePvLFwJQQJ99BKAC5RqLJkfMciAAABAZAC3CYE",
    cacheEnabled: true, // optional, defaults to true
    flagsToPrefetchOptimistic: [{ name: "roomassignment-frontend" }], // optional
  });

  Sentry.init({
    app,
    dsn: "https://1882560a3da3bf864dbe7c6593bc05ec@o378978.ingest.us.sentry.io/4510818535079936",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/eventservice.skischule-unterland\.de/, /^https:\/\/memberservice.skischule-unterland\.de/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    enableLogs: true, // Logs
    release: "ssu-app@" + store.getters.appVersion,
  });

  Sentry.setUser({ username: AuthenticationContext.getActiveAccount()?.username });
  app.use(Template)
  app.use(router)
  app.use(store)
  app.config.globalProperties.$toast = toast;


  app.mount('#app')
}

bootstrap()
